import qs from "query-string";
import { useCallback, useState } from "react";

import useService from "../../../../../../hooks/useService";

export default function useFetchDropdownData({
  setSelectedValue,
  url,
  queryParams,
  queryParamBuilder,
  searchText,
  customOnChange,
  fieldName,
}) {
  const enumRepository = useService("repositories/enum-repository");
  const [loading, setLoading] = useState(false);

  const handleOnChangeFieldValue = useCallback(
    (_fieldName, newValue) => {
      setSelectedValue(newValue ?? null);
      customOnChange?.(fieldName, newValue ? newValue.id : null);
    },
    [customOnChange, fieldName]
  );

  const fetchDropdownData = useCallback(async () => {
    if (!url) {
      return [];
    }

    try {
      setLoading(true);
      const mergedQueryParams = {
        ...(queryParams || {}),
        ...(searchText?.trim()
          ? typeof queryParamBuilder === "function"
            ? queryParamBuilder(searchText.trim())
            : { search: searchText.trim() }
          : {}),
      };
      const response = await enumRepository.query({
        urlPath: `${url}?${qs.stringify(mergedQueryParams)}`,
      });
      return response || [];
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      return [];
    } finally {
      setLoading(false);
    }
  }, [enumRepository, queryParamBuilder, queryParams, searchText, url]);

  return { fetchDropdownData, handleOnChangeFieldValue, loading };
}
